import { createElement, memo, useMemo } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import Sensor from '@max/mbc-sensor';
import Image from '@hfe/max-image';
import './index.scss';
import Slider from '@hfe/max-slider';
import { toPx } from '@max/leez-style-util';
const isMRN = false;
import { useMonitorEngineContext } from '@nibfe/mcp-monitor-sdk';
import { CLIENT_OS } from '@lowcode/mcp-protocol';
import { buildReportData } from '../../utils/report';
import { onNavigate } from '../../utils/navigate';
import LinearGradient from '@hfe/max-linear-gradient';
import { BID } from '../../const/bid';
const RANK_TAG_IMG = 'https://p0.meituan.net/ingee/d6977332ad27f0c449b17d525dd7780313294.png';
const getRealPx = (input) => {
    return isMRN ? toPx(input / 2) : `${input}rpx`;
};
function formatNumber(a) {
    const result = a + 1;
    return result < 10 ? `0${result}` : `${result}`;
}
const pagenationStyle = {
    dotStyle: {
        width: getRealPx(155),
        height: getRealPx(4),
        borderRadius: getRealPx(2),
        backgroundColor: '#FFFFFF66',
        display: 'flex',
        flex: 1
    },
    activeDotStyle: {
        width: getRealPx(155),
        height: getRealPx(4),
        borderRadius: getRealPx(2),
        backgroundColor: '#FFFFFFCC',
        display: 'flex',
        flex: 1
    },
    position: 'absolute',
    bottom: getRealPx(12),
    width: '100%',
    height: getRealPx(4),
    paddingLeft: getRealPx(12),
    paddingRight: getRealPx(12),
    borderRadius: getRealPx(2),
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
};
function RankPoiItem(props) {
    var _a, _b;
    const { highLightList = [], productName, score, recommendReason, actualPrice, rating, cardIndex } = props;
    const ctx = useMonitorEngineContext();
    const IS_ANDROID = ((_b = (_a = ctx === null || ctx === void 0 ? void 0 : ctx._runtimeInfo) === null || _a === void 0 ? void 0 : _a.commonParams) === null || _b === void 0 ? void 0 : _b.os) === CLIENT_OS.ANDROID;
    const isShowRankImg = useMemo(() => {
        if (cardIndex >= 0 && cardIndex <= 9) {
            return true;
        }
        return false;
    }, [cardIndex]);
    const highLightNameList = useMemo(() => {
        return highLightList.map(hightLightItem => {
            return hightLightItem.name;
        });
    }, [highLightList]);
    const jumpToPage = (cardProps, systemInfo) => {
        var _a, _b, _c, _d, _e, _f, _g;
        (_b = (_a = ctx === null || ctx === void 0 ? void 0 : ctx._LXReport) === null || _a === void 0 ? void 0 : _a.mcReport) === null || _b === void 0 ? void 0 : _b.call(_a, BID.CARD_MC, {
            valLab: buildReportData(cardProps)
        });
        const product = {
            productType: cardProps.productType,
            productIdStr: cardProps.productIdStr,
            extInfo: cardProps.extInfo
        };
        const query = {
            hotelchannel: (_e = (_d = (_c = ctx === null || ctx === void 0 ? void 0 : ctx._runtimeInfo) === null || _c === void 0 ? void 0 : _c.queryParams) === null || _d === void 0 ? void 0 : _d.hotelchannel) !== null && _e !== void 0 ? _e : '-999'
        };
        onNavigate(product, query, systemInfo !== null && systemInfo !== void 0 ? systemInfo : {}, (_f = cardProps === null || cardProps === void 0 ? void 0 : cardProps.poiIdListString) !== null && _f !== void 0 ? _f : '', (_g = cardProps === null || cardProps === void 0 ? void 0 : cardProps.poiIdUrlExtraParamsString) !== null && _g !== void 0 ? _g : '');
    };
    return <Sensor x-if={Array.isArray(highLightList) && highLightList.length > 0} className="rank-poi-item__wrapper" style={isShowRankImg ? {
            height: '410rpx',
            paddingTop: '15rpx'
        } : {}} once onAppear={() => {
            var _a, _b;
            (_b = (_a = ctx === null || ctx === void 0 ? void 0 : ctx._LXReport) === null || _a === void 0 ? void 0 : _a.mvReport) === null || _b === void 0 ? void 0 : _b.call(_a, BID.CARD_MV, {
                valLab: buildReportData(props)
            });
        }}>
      <View x-if={isShowRankImg} className="rank-poi-item__rank-img-wrapper">
        <Image className="rank-poi-item__rank-img" source={{
            uri: RANK_TAG_IMG
        }} resizeMode="contain"/>
        <Text className="rank-poi-item__rank-img-text" numberOfLines={1}>{formatNumber(cardIndex)}</Text>
      </View>
      <View className="rank-poi-item__info-wrapper">
        <Text className="rank-poi-item__title" numberOfLines={1}>
          {productName}
        </Text>
        <View className="rank-poi-item__review-info-wrapper">
          <Text x-if={score} className="rank-poi-item__score">
            {score}
          </Text>
          <Text x-if={rating} className="rank-poi-item__rating">
            {rating}
          </Text>
          <Text x-if={recommendReason} className="rank-poi-item__recommend">
            {recommendReason}
          </Text>
        </View>
        <View className="rank-poi-item__tags-wrapper">
          {highLightNameList.map((name, index) => {
            return <Text key={index} className="rank-poi-item__tag">
                {name}
              </Text>;
        })}
        </View>
      </View>
      <View x-if={actualPrice && parseInt(actualPrice, 10) > 0} className="rank-poi-item__price-wrapper">
        <Text className="rank-poi-item__price-prefix" style={isMRN && IS_ANDROID ? {
            paddingBottom: '6rpx'
        } : {}}>
          ¥
        </Text>
        <Text className="rank-poi-item__price-text">{actualPrice}</Text>
      </View>
      <Slider style={{
            borderRadius: '24rpx',
            overflow: 'hidden'
        }} width={toPx(702 / 2)} height={toPx(395 / 2)} autoPlay={false} index={0} loop showsPagination speed={300} cssEase="linear" direction={'horizontal'} paginationStyle={pagenationStyle} onChange={() => { }}>
        {highLightList.map((highLightItem, index) => {
            const { id, pictures } = highLightItem;
            return <Slider.Item key={id}>
              <View className="rank-poi-item__slider-item" onClick={() => {
                    jumpToPage(props, {});
                }}>
                <LinearGradient className="rank-poi-item__slider-mask" start={{
                    x: 0,
                    y: 0
                }} end={{
                    x: 0,
                    y: 1
                }} colors={['#00000000', '#00000066']}/>
                <Image className="rank-poi-item__slider-img" source={{
                    uri: pictures[0]
                }} resizeMode="cover"/>
              </View>
            </Slider.Item>;
        })}
      </Slider>
    </Sensor>;
}
export default memo(RankPoiItem);
